import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Serializer } from '../../Serializer';
import { generateGUID } from '../../utils/generate-uuid';
import { Logger } from '../../utils/Logger';
import { isAndroid, isIOS } from '../../utils/platform';
import { getQrData } from '../../utils/qr';
import { getTzip10Link } from '../../utils/get-tzip10-link';
import { windowRef } from '../../MockWindow';
import { closeAlerts } from './Alert';
import { Pairing, WalletType } from './Pairing';
var logger = new Logger('Alert');
var serializer = new Serializer();
export var preparePairingAlert = function preparePairingAlert(id, shadowRoot, pairingPayload) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var getInfo, info, container, buttonListWrapper, showWallet, listContainer, showWalletLists, messageFn, _closeFn, qr, copyButton, titleEl, platform, mainText, walletList, switchButton, clipboardFn, qrShown, showPlatform, showQr, switchPlatform, platformSwitch;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            getInfo = function getInfo() {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", Pairing.getPairingInfo(pairingPayload, function (_walletType, _wallet, keepOpen) {
                          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    if (!keepOpen) {
                                      _context.next = 2;
                                      break;
                                    }

                                    return _context.abrupt("return");

                                  case 2:
                                    _context.next = 4;
                                    return closeAlerts();

                                  case 4:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));
                        }, function () {
                          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    switchPlatform();

                                  case 1:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));
                        }));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
            };

            _context11.next = 3;
            return getInfo();

          case 3:
            info = _context11.sent;
            container = shadowRoot.getElementById("pairing-container");

            if (container) {
              _context11.next = 7;
              break;
            }

            throw new Error('container not found');

          case 7:
            buttonListWrapper = document.createElement('span');
            container.appendChild(buttonListWrapper);
            info.buttons.forEach(function (button) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var randomId, x, el, buttonEl;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return generateGUID();

                      case 2:
                        randomId = _context5.sent;
                        x = "\n    <div class=\"beacon-list__title\">".concat(button.title, "</div>\n\t\t<button class=\"beacon-modal__button connect__btn\">").concat(button.text, "</button>\n\t\t ");
                        el = document.createElement('a');
                        el.id = "button_".concat(randomId);
                        el.innerHTML = x;
                        buttonListWrapper.appendChild(el);
                        buttonEl = shadowRoot.getElementById(el.id);

                        if (buttonEl) {
                          buttonEl.addEventListener('click', function () {
                            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                while (1) {
                                  switch (_context4.prev = _context4.next) {
                                    case 0:
                                      button.clickHandler();

                                    case 1:
                                    case "end":
                                      return _context4.stop();
                                  }
                                }
                              }, _callee4);
                            }));
                          });
                        }

                      case 10:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));
            });

            showWallet = function showWallet(listEl, type, wallet) {
              var altTag = "Open in ".concat(wallet.name);
              var walletKey = wallet.key;
              var x = "\n    <a tabindex=\"0\" alt=\"".concat(altTag, "\" id=\"wallet_").concat(walletKey, "\"\n     target=\"_blank\" class=\"beacon-selection__list").concat(wallet.enabled ? '' : ' disabled', "\">\n     <div class=\"beacon-selection__name\">").concat(wallet.name, "\n     ").concat(wallet.enabled ? '' : '<p>Not installed</p>', "\n     </div>\n     ").concat(wallet.logo ? "<div>\n     <img class=\"beacon-selection__img\" src=\"".concat(wallet.logo, "\"/>\n     </div>") : '<svg class="beacon-selection__img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wallet" class="svg-inline--fa fa-wallet fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path d="M376.2,181H152.9c-5.2,0-9.4-4.2-9.4-9.4s4.2-9.4,9.4-9.4h225c5.2,0,9.4-4.2,9.4-9.4c0-15.5-12.6-28.1-28.1-28.1H143.5c-20.7,0-37.5,16.8-37.5,37.5v187.5c0,20.7,16.8,37.5,37.5,37.5h232.7c16.4,0,29.8-12.6,29.8-28.1v-150C406,193.6,392.7,181,376.2,181z M349.8,302.9c-10.4,0-18.8-8.4-18.8-18.8s8.4-18.8,18.8-18.8s18.8,8.4,18.8,18.8S360.1,302.9,349.8,302.9z"/></svg>', "\n    </a>\n     ");
              var el = document.createElement('span');
              el.innerHTML = x;
              listEl.appendChild(el);
              var walletEl = shadowRoot.getElementById("wallet_".concat(walletKey));

              var completeHandler = function completeHandler(event) {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  var modalEl;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!(event && event.key !== 'Enter')) {
                            _context6.next = 2;
                            break;
                          }

                          return _context6.abrupt("return");

                        case 2:
                          wallet.clickHandler();
                          modalEl = shadowRoot.getElementById('beacon-modal__content');

                          if (modalEl && type !== WalletType.EXTENSION && type !== WalletType.IOS) {
                            modalEl.innerHTML = "".concat(wallet.logo ? "<p class=\"beacon-alert__title\">Establishing Connection..</p>\n            <div id=\"beacon-toast-loader\" class=\"progress-line\"></div>\n            <div class=\"beacon--selected__container\">\n             <img class=\"beacon-selection__img\" src=\"".concat(wallet.logo, "\"/>\n             <div class=\"beacon--selection__name__lg\">").concat(wallet.name, "</div>\n            </div>") : '', "\n        ");
                          }

                        case 5:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
              };

              if (walletEl) {
                walletEl.addEventListener('click', function () {
                  return completeHandler();
                });
                walletEl.addEventListener('keydown', completeHandler);
              }
            };

            listContainer = document.createElement('span');
            container.appendChild(listContainer);

            showWalletLists = function showWalletLists(walletLists) {
              listContainer.innerHTML = '';
              walletLists.forEach(function (list) {
                var listWrapperEl = document.createElement('div');
                listWrapperEl.classList.add('beacon-list__wrapper');
                listContainer.appendChild(listWrapperEl);
                var listTitleEl = document.createElement('div');
                listTitleEl.classList.add('beacon-list__title');
                listTitleEl.innerHTML = list.title;
                listWrapperEl.appendChild(listTitleEl);
                var listEl = document.createElement('span');
                listWrapperEl.appendChild(listEl);
                list.wallets.forEach(function (wallet) {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            showWallet(listEl, list.type, wallet);

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));
                });
              });
            };

            showWalletLists(info.walletLists); // eslint-disable-next-line @typescript-eslint/no-explicit-any

            messageFn = function messageFn(event) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var newInfo;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!(event.data === 'extensionsUpdated')) {
                          _context8.next = 5;
                          break;
                        }

                        _context8.next = 3;
                        return getInfo();

                      case 3:
                        newInfo = _context8.sent;
                        showWalletLists(newInfo.walletLists);

                      case 5:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));
            }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _closeFn = function closeFn(event) {
              if (event.data === "closeAlert-".concat(id)) {
                windowRef.removeEventListener('message', messageFn);
                windowRef.removeEventListener('message', _closeFn);
              }
            };

            windowRef.addEventListener('message', messageFn);
            windowRef.addEventListener('message', _closeFn);
            qr = shadowRoot.getElementById("beacon--qr__container");
            copyButton = shadowRoot.getElementById("beacon--qr__copy");
            titleEl = shadowRoot.getElementById("beacon-title");
            platform = isAndroid(window) ? 'android' : isIOS(window) ? 'ios' : 'desktop';
            mainText = shadowRoot.getElementById("beacon-main-text");
            walletList = shadowRoot.getElementById("pairing-container");
            switchButton = shadowRoot.getElementById("beacon--switch__container"); // if (mainText && walletList && switchButton && copyButton && qr && titleEl) {

            clipboardFn = function clipboardFn() {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var code;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!pairingPayload) {
                          _context9.next = 10;
                          break;
                        }

                        _context9.t1 = serializer;
                        _context9.next = 4;
                        return pairingPayload.p2pSyncCode();

                      case 4:
                        _context9.t2 = _context9.sent;
                        _context9.next = 7;
                        return _context9.t1.serialize.call(_context9.t1, _context9.t2);

                      case 7:
                        _context9.t0 = _context9.sent;
                        _context9.next = 11;
                        break;

                      case 10:
                        _context9.t0 = '';

                      case 11:
                        code = _context9.t0;
                        navigator.clipboard.writeText(code).then(function () {
                          if (copyButton) {
                            copyButton.innerText = 'Copied';
                          }

                          logger.log('Copying to clipboard was successful!');
                        }, function (err) {
                          logger.error('Could not copy text to clipboard: ', err);
                        });

                      case 13:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));
            };

            qrShown = false;

            showPlatform = function showPlatform(type) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var platformSwitch, code, uri, qrSVG, qrString;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        platformSwitch = shadowRoot.getElementById("beacon-switch");

                        if (platformSwitch) {
                          platformSwitch.innerHTML = type === 'none' ? 'Pair wallet on same device' : 'Pair wallet on another device';
                        }

                        if (!(mainText && walletList && switchButton && copyButton && qr && titleEl)) {
                          _context10.next = 35;
                          break;
                        }

                        mainText.style.display = 'none';
                        titleEl.style.textAlign = 'center';
                        walletList.style.display = 'none';
                        switchButton.style.display = 'initial';
                        _context10.t0 = type;
                        _context10.next = _context10.t0 === 'ios' ? 10 : _context10.t0 === 'android' ? 12 : _context10.t0 === 'desktop' ? 14 : 19;
                        break;

                      case 10:
                        walletList.style.display = 'initial';
                        return _context10.abrupt("break", 35);

                      case 12:
                        walletList.style.display = 'initial';
                        return _context10.abrupt("break", 35);

                      case 14:
                        walletList.style.display = 'initial';
                        titleEl.style.textAlign = 'left';
                        mainText.style.display = 'none';
                        switchButton.style.display = 'initial';
                        return _context10.abrupt("break", 35);

                      case 19:
                        if (qrShown) {
                          _context10.next = 34;
                          break;
                        }

                        _context10.t1 = serializer;
                        _context10.next = 23;
                        return pairingPayload.p2pSyncCode();

                      case 23:
                        _context10.t2 = _context10.sent;
                        _context10.next = 26;
                        return _context10.t1.serialize.call(_context10.t1, _context10.t2);

                      case 26:
                        code = _context10.sent;
                        uri = getTzip10Link('tezos://', code);
                        qrSVG = getQrData(uri, 'svg');
                        qrString = qrSVG.replace('<svg', "<svg class=\"beacon-alert__image\"");
                        qr.insertAdjacentHTML('afterbegin', qrString);

                        if (copyButton) {
                          copyButton.addEventListener('click', clipboardFn);
                        }

                        if (qr) {
                          qr.addEventListener('click', clipboardFn);
                        }

                        qrShown = true;

                      case 34:
                        // QR code
                        mainText.style.display = 'initial';

                      case 35:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));
            };

            showQr = false;

            switchPlatform = function switchPlatform() {
              showPlatform(showQr ? 'none' : platform);
              showQr = !showQr;
            };

            switchPlatform();
            platformSwitch = shadowRoot.getElementById("beacon-switch");

            if (platformSwitch) {
              platformSwitch.addEventListener('click', switchPlatform);
            }

          case 34:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};